import BaseRoute from "utils/base_route";

import WorkflowList from "./containers/workflow_list";

export default class WorkflowListRoute extends BaseRoute {
  constructor(store) {
    super("list", store);
  }

  getChildRoutes(state, cb) {
    cb(null, []);
  }
  getComponents(location, cb) {
    cb(null, WorkflowList);
  }
}
